import { ExpensesTripInformationFormFragment } from 'generated/resources/graphql'

export const getTripInformationAttributes = (data: ExpensesTripInformationFormFragment) => {
  return {
    to: data?.perDiem?.to,
    from: data?.perDiem?.from,
  }
}
